import { render, staticRenderFns } from "./TOSView.vue?vue&type=template&id=5371763c&scoped=true&"
import script from "./TOSView.vue?vue&type=script&lang=js&"
export * from "./TOSView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/terms.css?vue&type=style&index=0&id=5371763c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371763c",
  null
  
)

export default component.exports